import CitySEOHead from "@/components/feature/CitySEOHead";
import AKHeroSection from "./components/HeroSection";
import AKCitiesDirectory from "./components/CitiesDirectory";
import AKStateResources from "./components/StateResources";
import AKFAQSection, { faqs } from "./components/FAQSection";
import AKFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const alaskaFaqs = faqs.map((f: { question: string; answer: string }) => ({ q: f.question, a: f.answer }));

const alaskaServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function AlaskaPage() {
  return (
    <>
      <CitySEOHead
        city="Alaska"
        state="Alaska"
        stateAbbr="AK"
        route="/states/alaska"
        title="Alaska Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Alaska — Anchorage, Juneau, Fairbanks, Sitka, Ketchikan, and the Mat-Su Valley. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Alaska, United States"
        geoPosition="64.2008;-153.4937"
        faqs={alaskaFaqs}
        servicesSchema={alaskaServices}
      />
      <div className="font-sans">
        <AKHeroSection />
        <AKCitiesDirectory />
        <AKStateResources />
        <AKFAQSection />
        <SEOCrossLinks state="AK" />
        <AKFinalCTA />
      </div>
    </>
  );
}